import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthenticationService } from './authentication.service';
import {ClientRequest} from  '../../ClientRequest';


@Injectable()
export class ElearningService {
  constructor(private clientRequest: ClientRequest) {}

  /*Find Course Time Table*/
  findCourseTimeTable(id): Observable<any> {
    return this.clientRequest.get('/elearning/content/' + id+'?field=timetable').map(response => {
        return response;
    });
  }
  find(id): Observable<any> {
    return this.clientRequest.get('/elearning/' + id).map(response => {
        return response;
    });
  }
  findPackages(id, child_id=0): Observable<any> {
    return this.clientRequest.get('/packages/' + id+'?child_id='+child_id).map(response => {
        return response;
    });
  }
  listPackages(id): Observable<any> {
    return this.clientRequest.get('/packages/list/' + id).map(response => {
        return response;
    });
  }
  findSections(enroll_id, data): Observable<any> {
    return this.clientRequest.get('/elearning/lessons/'+enroll_id, data)
    .map(response => {
      return response;
    });
  };

  saveProgress(enroll_id, data): Observable<any> {
    return this.clientRequest.get('/elearning/lessons/save/' + enroll_id, data)
    .map(response => {
      return response;
    });
  };

  /*****************************Find Course Quiz************************/
  findQuiz(enrol_id, data): Observable<any> {
    return this.clientRequest.get('/elearning/quiz/' + enrol_id, data).map(response => {
      return response;
    });
  };
  startQuiz(enrol_id, id): Observable<any> {
    return this.clientRequest.post('/elearning/quiz/start/' + enrol_id + '?question=' + id, {}).map(response => {
      return response;
    });
  };
  resumeAttempt(enrol_id, id): Observable<any> {
    return this.clientRequest.post('/elearning/quiz/resume-attempt/' + enrol_id + '?question=' + id, {}).map(response => {
      return response;
    });
  };
  getLastAttempt(enrol_id, data): Observable<any> {
    return this.clientRequest.get('/elearning/quiz/last-attempt/' + enrol_id, data).map(response => {
      return response;
    });
  };
  submitQuiz(enrol_id, questionID, data): Observable<any> {
    return this.clientRequest.post('/elearning/quiz/submit/'+enrol_id+'?question=' + questionID,data)
    .map(response => {
      return response;
    });
  }
  pauseQuiz(enrol_id, questionID, data): Observable<any> {
    return this.clientRequest.post('/elearning/quiz/paused/'+enrol_id+'?question=' + questionID,data)
    .map(response => {
      return response;
    });
  }
  findQuizHistories(enrol_id, data): Observable<any> {
    return this.clientRequest.get('/elearning/quiz/data/'+enrol_id, data).map(response => {
      return response;
    });
  };
  findQuizHistory(enrol_id, data): Observable<any> {
    return this.clientRequest.get('/elearning/quiz/history/'+enrol_id, data).map(response => {
      return response;
    });
  };
  /*****************************END-Quiz************************/


  /*****************************QUESTION-ASNSWER************************/
  loadQa(id, data): Observable<any> {
    return this.clientRequest.get('/elearning/qa/data/'+id, data).map(response => {
      return response;
    })
  }

  loadSubQa(id, data): Observable<any> {
    return this.clientRequest.get('/elearning/qa/sub/'+id, data).map(response => {
      return response;
    })
  }

  storeQa(id, data): Observable<any> {
    return this.clientRequest.post('/elearning/qa/store/'+id, data).map(response => {
      return response;
    })
  }
  /*****************************END-QUESTION-ANSWER************************/

}
